import { CspEnvironmentEnumDTO } from '@openApiGenerated/management-api';

export class CspAccountBase {
	public cspKeyReference: string = undefined;
}

export class CspAccount extends CspAccountBase {
	public cspKeyReference: string = undefined;

	public certificateStartDate: Date = undefined;

	public certificateEndDate: Date = undefined;

	public environment?: CspEnvironmentEnumDTO = undefined;
}

export class CspAccountResponse extends CspAccountBase {
	public cspKeyReference: string = undefined;

	public certificateStartDate: string = undefined;

	public certificateEndDate: string = undefined;
}


export enum CspStatus {
	ACTIVE = 'active',
	DELETED = 'deleted',
	DISABLED = 'disabled',
	INACTIVE = 'inactive',
	INVALID = 'invalid',
	PREINIT = 'preinit',
	SUSPENDED = 'suspended'
}
